// import { Divider, Flex } from "@chakra-ui/react";
import { toFixedWithoutRounding } from "@constants/common";
import useBridgeWrapConfig from "@hooks/useBridgeWrapConfig";
import useTokenBalanceForChain from "@hooks/useTokenBalanceForChain";
import useVaultSwapTokensBalancesChain from "@hooks/useVaultSwapTokenBalancesChain";
import { Accordion } from "@kelp-dao/kernel-design-system";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUnwrapTxnState } from "store/slices/globalSlice";
import { formatNumber } from "utils";
import { formatUnits } from "viem";
// import AccordianItemWrapper from "../BridgeWrap/AccordianItemWrapper";
import { ALL_STEPS, BW_VARIANT, TChainSelection } from "../BridgeWrap/types";
import AccordianItemWrapperV2 from "./AccordianItemWrapperV2";
import BridgeAccordionV2 from "./BridgeAccordionV2";
import WrapUnwrapAgEthAccordianV2 from "./WrapUnwrapAgEthAccordianV2";

interface AgEthJourneyStepsV2Props {
  sourceChain: TChainSelection;
  destinationChain: TChainSelection;
}

const AgEthJourneyStepsV2 = ({
  sourceChain,
  destinationChain,
}: AgEthJourneyStepsV2Props) => {
  const BRIDGE_WRAP_DATA = useBridgeWrapConfig(BW_VARIANT.RSETH);

  const { agETHBalance, wagETHBalance } = useVaultSwapTokensBalancesChain(
    sourceChain.id
  );
  const { xTokenVaultBalance } = useTokenBalanceForChain(sourceChain?.id!);

  const dispatch = useDispatch();

  const txnSuccess = useSelector(
    (state: any) => state?.global?.unwrapTxnState?.success
  );

  useEffect(() => {
    if (txnSuccess) {
      dispatch(
        updateUnwrapTxnState({
          success: false,
        })
      );
    }
  }, [sourceChain, destinationChain]);

  const hasWagETH =
    Number(toFixedWithoutRounding(formatUnits(wagETHBalance, 18), 4)) > 0;

  const sourceBalance =
    sourceChain.id === 1
      ? Number(
        formatNumber(
          Number(xTokenVaultBalance),
          false,
          Number(xTokenVaultBalance) < 0.0001 ? 6 : 4,
          true
        )
      )
      : Number(formatUnits(agETHBalance, 18));

  const assetSelected = hasWagETH
    ? BRIDGE_WRAP_DATA.assets[2]
    : BRIDGE_WRAP_DATA.assets[3];

  const generateSteps = () => {
    const STEPS: string[] = [];

    if (sourceChain.id === destinationChain.id && sourceChain.id !== 1) {
      STEPS.push(ALL_STEPS.WRAP);
    } else if (sourceChain.id === 1 && destinationChain.id !== 1) {
      STEPS.push(ALL_STEPS.BRIDGE);
      STEPS.push(ALL_STEPS.WRAP);
    } else if (sourceChain.id !== 1 && destinationChain.id === 1) {
      if (hasWagETH || txnSuccess) STEPS.push(ALL_STEPS.UNWRAP);
      STEPS.push(ALL_STEPS.BRIDGE);
    } else if (sourceChain.id !== 1 && destinationChain.id !== 1) {
      if (hasWagETH || txnSuccess) STEPS.push(ALL_STEPS.UNWRAP);
      STEPS.push(ALL_STEPS.BRIDGE);
      STEPS.push(ALL_STEPS.WRAP);
    } else {
      STEPS.push(ALL_STEPS.BRIDGE);
    }
    return STEPS;
  };

  const renderStep = (step: string, idx: number) => {
    switch (step) {
      case ALL_STEPS.BRIDGE:
        return (
          <AccordianItemWrapperV2
            prefixLabel={`Step ${idx}:`}
            label={`Bridge your tokens`}
            value={`step-${idx}`}
            element={
              <BridgeAccordionV2
                isAgETH={true}
                fromChain={sourceChain}
                toChain={destinationChain}
                fromSymbol={
                  sourceChain.id === 1
                    ? BRIDGE_WRAP_DATA.assets[2].id
                    : BRIDGE_WRAP_DATA.assets[3].id
                }
                toSymbol={BRIDGE_WRAP_DATA.assets[3].id}
                tokenAmount={
                  sourceBalance
                    ? +toFixedWithoutRounding(sourceBalance.toString(), 4)
                    : 0
                }
              />
            }
          />
        );
      case ALL_STEPS.WRAP:
        return (
          <AccordianItemWrapperV2
            prefixLabel={`Step ${idx}:`}
            label={`Wrap your tokens`}
            value={`step-${idx}`}
            element={
              <WrapUnwrapAgEthAccordianV2
                type="wrap"
                sourceChain={sourceChain}
                destinationChain={destinationChain}
              />
            }
          />
        );
      case ALL_STEPS.UNWRAP:
        return (
          <AccordianItemWrapperV2
            prefixLabel={`Step ${idx}:`}
            label={`Unwrap your tokens`}
            value={`step-${idx}`}
            element={
              <WrapUnwrapAgEthAccordianV2
                type="unwrap"
                sourceChain={sourceChain}
                destinationChain={destinationChain}
              />
            }
          />
        );
      default:
        return null;
    }
  };

  if (sourceChain.id === 1 && destinationChain.id === 1) {
    return null;
  }

  return (
    <div className="flex flex-col gap-[10px] w-full">
      {assetSelected?.id && (
        <Accordion
          type="multiple"
          defaultValue={["step-1", "step-2", "step-3"]}
          className="w-full flex flex-col"
        >
          {generateSteps()?.map((step, index) => {
            return (
              <>
                {/* {index > 0 && <hr className="bg-[#B3CECE] h-[1px]" />} */}
                {renderStep(step, index + 1)}
              </>
            );
          })}
        </Accordion>
      )}
      {/* {generateSteps().length > 0 && <hr className="bg-[#B3CECE] h-[1px]" />} */}
    </div>
  );
};

export default AgEthJourneyStepsV2;
